<template>
    <div class="result" v-if="result">
        <div class="d-flex thumb-inner-images flex-column justify-space-between align-center">
            <v-img
                contain
                class="rounded-lg"
                max-width="100%"
                :src="result.photo"
                :lazy-src="result.photo"
                crossOrigin="true" 
            ></v-img>
        </div> 

        <div class="title_cover mt-5">
            <h3>{{$parent.uniquesso(result.title||'')}}</h3>
        </div>
        <div class="description mt-3" v-html="result.description"></div>

        <share :data_api="data_api" :currentUrl="currentUrl" :playAgain="!data_api.is_unique" :shareNav="true" :title="result.title||null" :description="result.description||null"/>
    </div>
</template>

<script>
const Share = () => import(/* webpackChunkName: "share" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ '../Share.vue');

export default {
  name: "ResultTrivia",
  props:['data_api', 'currentUrl'],
  components: { Share },
  data() {
    return {
        //currentUrlResult: this.currentUrl+='&rid='+this.result.id,
        result: this.$store.state.triviaResult
    }
},
  mounted()
  {
      if( !this.$store.state.triviaResult ) return this.$router.push({name:'question'})
        
      //this.currentUrlResult = this.currentUrl+='&rid='+this.result.id
  }
}
</script>